import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import React from 'react';
import { ActionType, Integration } from '../services/api/types';
import IntegrationAccount from './IntegrationAccount';

interface props {
  integration: Integration;
  onClose: (accountId: string) => void;
  editAccount: (accountId: string, action: ActionType) => void;
}

export default function AccountList(props: props) {
  return (
    <P2GGrid direction="column" spacing={1} container>
      {props.integration.accounts.map((a) => (
        <P2GGrid item key={`${a.id}_${a.name}`}>
          <IntegrationAccount
            integration={props.integration}
            onClose={props.onClose}
            account={a}
            editAccount={(action) => props.editAccount(a.id, action)}
          />
        </P2GGrid>
      ))}
    </P2GGrid>
  );
}
